__turbopack_context__.v({
  "collapsed": "UNGduG_collapsed",
  "content": "UNGduG_content",
  "gradient": "UNGduG_gradient",
  "root": "UNGduG_root",
  "toggleBtn": "UNGduG_toggleBtn",
});
